import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'myRound'
})

export class MyRound implements PipeTransform {

    transform(value: number, nbDecimal: number): any {
        if (nbDecimal < 0 ) {
          return value;
        }
            const p  = Math.pow(10, nbDecimal);
            return Math.round( value * p ) / p;
    }
}
